import { render, staticRenderFns } from "./ContentBoxDialog.vue?vue&type=template&id=2e9ae170&scoped=true&"
import script from "./ContentBoxDialog.vue?vue&type=script&lang=js&"
export * from "./ContentBoxDialog.vue?vue&type=script&lang=js&"
import style0 from "./ContentBoxDialog.vue?vue&type=style&index=0&id=2e9ae170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9ae170",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VForm,VIcon,VSwitch,VTextField})
